
import React from 'react'
import Layout from '../../components/layout'
import SectionHeading from '../../components/SectionHeading'

import EmployeeSelector from '../../components/EmployeeSelector'

// Avatars
import avatar_jl from '../../assets/employees/johan-profil.jpg'
import avatar_gl from '../../assets/employees/gustav-profil.jpg'
import avatar_rn from '../../assets/employees/robert-profil.jpg'
import avatar_dh from '../../assets/employees/david-profil.jpg'
import avatar_jh from '../../assets/employees/jocke-profil.jpg'
import avatar_db from '../../assets/employees/dennis-profil.jpg'
import avatar_ml from '../../assets/employees/mattias-profil.jpg'
import avatar_me from '../../assets/employees/malin-profil.jpg'
import avatar_el from '../../assets/employees/emanuel-profil.jpg'
import avatar_il from '../../assets/employees/isak-profil.jpg'
import avatar_kg from '../../assets/employees/kalle-profil.jpg'
import avatar_ev from '../../assets/employees/emil-profil.jpg'
import avatar_ma from '../../assets/employees/martin-profil.jpg'
import avatar_wt from '../../assets/employees/wilhelm-profil.jpg'
import avatar_fb from '../../assets/employees/fredrik-profil.jpg'
import avatar_jp from '../../assets/employees/johannes-profil.jpg'

// Certlogos
import CCNA from '../../assets/certifications/ccna.jpg'
import CCIE_E from '../../assets/certifications/ccie_enterprise.jpg'
import CCIE_DC from '../../assets/certifications/ccie_datacenter.jpg'
import CCIE_SP from '../../assets/certifications/ccie_servprov.jpg'
import CCIE_S from '../../assets/certifications/ccie_security.jpg'
import CCIE_A from '../../assets/certifications/ccie_automation.jpg'
import CCDE from '../../assets/certifications/ccde_design.jpg'

import CCDP from '../../assets/certifications/ccdp.jpg'
import CCNP_A from '../../assets/certifications/ccnp_automation.png'
import CCNA_A from '../../assets/certifications/ccna_automation.png'

import D500 from '../../assets/certifications/devnet500.jpg'
import CCNP_ENT from '../../assets/certifications/ccnp_enterprise.jpg'
import CCNP_SP from '../../assets/certifications/ccnp_sp.jpg'
import CISCO_SPEC from '../../assets/certifications/cisco_specialist.jpg'


const employees = [
  {
    name: "Johan Lahti",
    avatar: avatar_jl,
    title: "Sr. Consultant & CEO",
    certifications: [
      { name: "CCIE Enterprise", logo: CCIE_E },
      { name: "CCNP Automation", logo: CCNP_A },
      { name: "Cisco Certified Design Professional", logo: CCDP },
      { name: "DevNet500", logo: D500 }
    ],
    text: "Johan är grundare av Acebit och har över 15 års erfarenhet av IT-branschen och framförallt nätverk. Han är tungt tekniskt certifierad och innehar bland annat Ciscos högsta nivå - CCIE R&S, och även CCNP Automation och CCDP. Johan har också fått andra utmärkelser såsom DevNet500 och Cisco Champion (2022, 2023 2024)."
  },
  {
    name: "Gustav Larsson",
    avatar: avatar_gl,
    title: "Sr. Consultant",
    certifications: [
      { name: "CCIE Enterprise", logo: CCIE_E },
      { name: "CCIE Automation", logo: CCIE_A }
    ],
    text: "Gustav har på kort tid tagit sig väl in i IT-branchen - och på bara 5 år åstadkommit att bli Cisco CCIE-certifierad inom både Enterprise och Automation, samt satsat hårt på att spetsa kompetensen kring systemutveckling, med fokus på att skapa applikationer och system som löser verksamhetsbehov inom infrastruktur."
  },
  {
    name: "Robert Nilsson",
    avatar: avatar_rn,
    title: "Sr. Consultant & Manager",
    certifications: [
      { name: "CCNP Enterprise", logo: CCNP_ENT },
      { name: "CCNP Service Provider", logo: CCNP_SP },
      { name: "CCNA Automation", logo: CCNA_A }
    ],
    cert_logos: [],
    text: "Robert har jobbat med datornätverk i mer än 10 år. Han har erfarenhet av datacenter-, tjänsteleverantörs- och kontorsnät; detta ger honom en bred förståelse för olika behov och teknologier. Robert är även certifierad CCNA Automation och CCNP inom både Routing & Switching (idag Enterprise) och Service Provider."
  },
  {
    name: "Joakim Hag",
    avatar: avatar_jh,
    title: "Consultant",
    certifications: [
      { name: "CCNP Enterprise", logo: CCNP_ENT },
      { name: "CCNP Automation", logo: CCNP_A },
    ],
    cert_logos: [],
    text: "Joakim har över 10 års erfarenhet av IT-branschen, sedan 2016 har hans fokus varit nätverk. Han är certifierad CCNP inom Routing & Switching (idag Enterprise), DevNet Specialist på Enterprise spåret och CCNP Automation."
  },
  {
    name: "Emil Vonck",
    avatar: avatar_ev,
    title: "Sr. Consultant",
    certifications: [
      { name: "CCIE Automation", logo: CCIE_A },
      { name: "CCNP Enterprise", logo: CCNP_ENT },
    ],
    cert_logos: [],
    text: "Emil har en lång bakgrund inom nätverk och infrastruktur, men har på senare tid specialiserat sig inom nätverksautomation och programmering. Emil är certifierad Cisco CCIE Automation samt CCNP Enterprise, och har stor erfarenhet av att hjälpa kunder med att automatisera och effektivisera sina nätverksmiljöer."
  },
  {
    name: "Dennis Bäckstedt",
    avatar: avatar_db,
    title: "Consultant",
    certifications: [
      { name: "CCNA Automation", logo: CCNA_A },
      { name: "Cisco Meraki Solutions Specialist", logo: CISCO_SPEC },
    ],
    text: "Dennis har arbetat inom IT i snart 10 år. Han har bred erfarenhet av Cisco-produkter och är särskilt inriktad på arbete med Wi-Fi-lösningar innefattande design, implementation och felsökning. Dennis värdesätter att verkligen förstå sina kunders verksamhet, inte bara IT-delen, vilket han anser är avgörande för att leverera en bra lösning."
  },
  {
    name: "Mattias Liljestrand",
    avatar: avatar_ml,
    title: "Consultant",
    certifications: [
      { name: "CCNA Automation", logo: CCNA_A },
      { name: "Cisco Certified Network Associate", logo: CCNA },
      { name: "CCNP Enterprise", logo: CCNP_ENT },
    ],
    text: "Mattias har en bakgrund som professionell fotbollsspelare under hela yrkeslivet och har nu bytt bana till IT. Efter att ha genomfört en YH-utbildning i Moln och virtualisering, samt praktik hos Acebit, har Mattias tagit steget in i nätverksbranschen. Han har idag, bara något år in i branschen, redan certifierat sig till CCNA, CCNA Automation och CCNP Enterprise."
  },
  {
    name: "Isak Ljunggren",
    avatar: avatar_il,
    title: "Consultant",
    certifications: [
      { name: "Cisco Certified Network Associate", logo: CCNA },
      { name: "CCNA Automation", logo: CCNA_A }
    ],
    text: "Isak har på kort tid kommit in starkt i IT-branchen, med goda kunskaper inom systemutveckling och DevOps-arbetssätt har han kunnat bidra från start med att hjälpa våra kunder bygga nätverk på det moderna, skalbara sättet Acebit bygger framtidens nätverk."
  },
  {
    name: "David Heidenberg",
    avatar: avatar_dh,
    title: "Consultant",
    certifications: [
      { name: "Cisco Certified Network Associate", logo: CCNA },
    ],
    text: "David är nytt stjärnskott till branschen som på kort tid kommit in med stort driv, nyfikenhet och vilja att lära sig allt inom nätverk och infrastruktur. David har arbetat mycket med Aruba Wireless, och tagit en Cisco CCNA Certifiering. Med god kundkontakt och proffsigt bemötande finns det inga utmaningar han inte kan lösa!"
  },
  // TODO: fyll i titel, certifikat och text för de nya
  {
    name: "Martin Augustsson",
    avatar: avatar_ma,
    title: "Consultant",
    certifications: [
      { name: "CCNA Automation", logo: CCNA_A }
    ],
    text: "Martin har flera års erfarenhet inom nätverk, med bakgrund inom drift och utveckling av nätverksmiljöer. De senaste åren har han specialiserat sig inom nätverksautomation, med fokus på att effektivisera och automatisera nätverksdrift."
  },
  {
    name: "Johannes Påander",
    avatar: avatar_jp,
    title: "Consultant",
    certifications: [
      { name: "Cisco Certified Network Associate", logo: CCNA },
    ],
    text: "Johannes är en social och lättpratad person som snabbt skapar förtroende hos både kunder och kollegor. Branschen är fortfarande ny för Johannes, men tempot framåt är högt och nyfikenheten stor. Det som verkligen sticker ut är ansvarstagandet: när ett problem dyker upp väntar Johannes inte på att någon annan ska agera, utan plockar upp telefonen och ser till att det blir löst. Ett driv och en attityd som passar perfekt in i Acebit-sättet!"
  },
  {
    name: "Wilhelm Törnblom",
    avatar: avatar_wt,
    title: "Consultant",
    certifications: [
      { name: "CCNA Automation", logo: CCNA_A }
    ],
    text: "Wilhelm har på kort tid kommit in starkt i IT-branschen. Med goda kunskaper inom DevOps, CI/CD och automatisering hjälper han våra kunder att bygga moderna, automatiserade nätverk. Hans nyfikenhet och prestigelöshet gör att han snabbt tar sig an nya utmaningar."
  },
  {
    name: "Malin Ekstrand",
    avatar: avatar_me,
    title: "Administrator",
    certifications: [],
    text: ""
  },
  {
    name: "Emanuel Lipschütz",
    avatar: avatar_el,
    title: "Chairman of the board",
    certifications: [
      { name: "CCIE Enterprise", logo: CCIE_E },
      { name: "CCIE Data Center", logo: CCIE_DC },
      { name: "CCIE Service Provider", logo: CCIE_SP },
      { name: "CCIE Security", logo: CCIE_S },
      { name: "Cisco Certified Design Expert", logo: CCDE }
    ],
    text: "Emanuel är styrelseordförande i Acebit och har över 25 års erfarenhet inom nätverk och cybersäkerhet och jobbat med ett stort antal företag och organisationer inom olika vertikaler. Emanuel har tagit inte mindre än 4 CCIE certifieringar, R&S, Security, Service Provider och Datacenter. Han har även motsvarande certifiering inom design, CCDE. Emanuel är också instruktör och är ensam i Sverige med att ha fått utmärkelsen Sirius Top Quality Instructor Award av Cisco. Emanuel är serieentreprenör och har fått utmärkelser och erkännande för det, bla Årets Företagare Stockholm Stad 2010."
  },
  {
    name: "Kalle Gustafsson",
    avatar: avatar_kg,
    title: "Business Development Manager",
    group: "Sales",
    contact: { phone: "072-602 16 06", phoneHref: "+46726021606", email: "kalle.gustafsson@acebit.se" },
    certifications: [],
    text: "Kalle har över 10 års erfarenhet av sälj inom olika tekniska områden. både B2C samt B2B försäljning av ruggad hårdvara till företag inom tung industri. Nu är siktet inställt på att hjälpa företag och organisationer att få bättre, säkrare och mer lättskötta nätverk tillsammans med teamet på Acebit!"
  },
  {
    name: "Fredrik Broéng",
    avatar: avatar_fb,
    title: "Business Development Manager",
    group: "Sales",
    contact: { phone: "079-588 05 04", phoneHref: "+46795880504", email: "fredrik.broeng@acebit.se" },
    certifications: [],
    text: "Fredrik har över 15 års erfarenhet av försäljning och ledarskap inom IT och teknik, bland annat från Nordlo, Canon och Kjell & Company. Han gör affärer på Acebit-sättet: kundens affärsbehov styr lösningen, aldrig hårdvaran eller leverantören. Med ärlighet, flexibla upplägg och förutsägbara kostnader bygger han långsiktiga partnerskap där kunden stannar för att den vill, inte för att den måste. Allt tillsammans med teamet på Acebit!"
  }
]

export default function EmployeesPage() {

  return (
    <Layout>
      <div id="employees" className="section flex flex-col gap-10 sm:gap-14">
        <SectionHeading
          eyebrow="Medarbetare"
          title={<>Vi är <span className="text-sky-500">Acebit</span></>}
        />
        <EmployeeSelector employees={employees} />
      </div>
    </Layout>
  )
}
